import { render } from "./ResetPWD.vue?vue&type=template&id=15e95632&scoped=true"
import script from "./ResetPWD.vue?vue&type=script&lang=js"
export * from "./ResetPWD.vue?vue&type=script&lang=js"

import "./ResetPWD.vue?vue&type=style&index=0&id=15e95632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e95632"]])

export default __exports__